import React from "react";

export default function GraphCountry({ graphCountry }) {
  return <option value={graphCountry}>{graphCountry}</option>;
}
